import React from 'react';
import { getStatusKey } from '../StatusBadge/StatusBadge';
import './InventarioSummary.css';

function InventarioSummary({ data = [] }) {
    const stats = React.useMemo(() => {
        let assigned = 0;
        let inMaintenance = 0;
        let inStock = 0;
        let retired = 0;
        data.forEach((h) => {
            const key = getStatusKey(h.siteqp, h.comVinculo);
            if (key === 'assigned') assigned++;
            else if (key === 'inMaintenance') inMaintenance++;
            else if (key === 'inStock') inStock++;
            else if (key === 'retired') retired++;
        });
        const total = assigned + inStock + inMaintenance;
        return { total, assigned, inMaintenance, inStock, retired };
    }, [data]);

    return (
        <div className="inventario-summary">
            <div className="inventario-summary__card inventario-summary__card--total">
                <span className="inventario-summary__value">{stats.total}</span>
                <span className="inventario-summary__label">Total de ativos</span>
            </div>
            <div className="inventario-summary__card inventario-summary__card--assigned">
                <span className="inventario-summary__value">{stats.assigned}</span>
                <span className="inventario-summary__label">Atribuídos</span>
            </div>
            <div className="inventario-summary__card inventario-summary__card--inStock">
                <span className="inventario-summary__value">{stats.inStock}</span>
                <span className="inventario-summary__label">Em estoque</span>
            </div>
            <div className="inventario-summary__card inventario-summary__card--inMaintenance">
                <span className="inventario-summary__value">{stats.inMaintenance}</span>
                <span className="inventario-summary__label">Em manutenção</span>
            </div>
            <div className="inventario-summary__card inventario-summary__card--retired">
                <span className="inventario-summary__value">{stats.retired}</span>
                <span className="inventario-summary__label">Baixados</span>
            </div>
        </div>
    );
}

export default InventarioSummary;
